import request from '@/utils/request'
import { cmsServerContext } from '@/config/config'
import { getToken } from '@/utils/auth'

/**
 * 空接口，为检测是否需要短信认证
 */
export function checkSmsAuth() {
  return request({
    url: cmsServerContext + '/smsAuth/check',
    method: 'get'
  })
}

/**
 * 发送短信二次认证验证码
 * @param customerUserId
 */
export function sendVcode(customerUserId) {
  return request({
    url: cmsServerContext + '/smsAuth/sendVcode',
    method: 'post',
    data: {token: getToken(), customerUserId: customerUserId}
  })
}

/**
 * 验证短信验证码
 * @param vcode
 */
export function smsAuth(vcode) {
  return request({
    url: cmsServerContext + '/smsAuth/auth',
    method: 'post',
    data: {token: getToken(), vcode: vcode}
  })
}